export { default } from './HoldsAdditionalBriefInfo';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsAdditionalBriefInfo/index.js